import { useEffect } from 'react';
import {
    MenuItem,
    InputLabel,
    FormControl,
    Select
} from '@mui/material';
import useFetch from 'modules/customHooks/useFetch';
import { clientIdsWithExternalPermission, getExternalClientPermissions } from '../../../helpers/externalClientPermissions';

export const ClientNameDropdown = ({
    selectedClientId,
    setSelectedClientId,
    setPaginationModel,
    pageName,
    setPage
}: any) => {
    const [userInfo] = useFetch();
    const jwt = localStorage.getItem('token');
    const labUserCheck = jwt ? JSON.parse(atob(jwt.split('.')[1] || '')) : null;
    // Show every client the user has - permission gating happens on the page itself once a client is picked
    const visibleClients = userInfo?.userMap;

    const handleClientName = (event: any) => {
        const newClientId = Number(event.target.value);
        setSelectedClientId(newClientId);
        if (labUserCheck?.UserType === 'External') {
            localStorage.setItem('selectedClientId', newClientId.toString());
        }
        if (pageName === "home") {
            window.history.replaceState(null, '', '/home');
            setPage(0);
        }
        if (typeof setPaginationModel === 'function') {
            setPaginationModel((old: any) => ({ ...old, page: 1 }));
        }
    };

    // Default to the last selected client (localStorage) when the current selection isn't visible yet -
    // shared here so ViewQuote, UserManagement and OrderHistory all default/persist the same way
    useEffect(() => {
        if (!visibleClients?.length) return;

        const hasValidSelection = selectedClientId &&
            visibleClients.some((client: any) => String(client.clientID) === String(selectedClientId));

        // Parent pages can set a valid selectedClientId on their own (not via handleClientName) - persist it too
        if (hasValidSelection) {
            if (labUserCheck?.UserType === 'External') {
                localStorage.setItem('selectedClientId', String(selectedClientId));
            }
            return;
        }

        const savedClientId = labUserCheck?.UserType === 'External' ? localStorage.getItem('selectedClientId') : null;
        const savedClient = savedClientId && visibleClients.find((client: any) => String(client.clientID) === savedClientId);
        const defaultClientId = savedClient ? savedClient.clientID : visibleClients[0].clientID;

        setSelectedClientId(defaultClientId);
        if (labUserCheck?.UserType === 'External') {
            localStorage.setItem('selectedClientId', defaultClientId.toString());
        }
    }, [visibleClients, selectedClientId]);

    return (
        <div>
            {userInfo?.userType === 'External' && userInfo?.userMap !== null ? (
                <FormControl
                    sx={{
                        minWidth: 340,
                        maxWidth: '100%',
                    }}
                >
                    <InputLabel id="client-name-select-label">Client Name</InputLabel>
                    <Select
                        labelId="client-name-select-label"
                        id="client-name-select"
                        label="Client Name"
                        size="small"
                        value={selectedClientId}
                        onChange={handleClientName}
                        sx={{ fontSize: '12px' }}
                    >
                        {visibleClients?.map((i: any) => (
                            <MenuItem key={i?.clientID} value={i?.clientID} sx={{ fontSize: '12px' }}>
                                {i?.clientName}
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>
            ) : null}
        </div>
    );
};
